




















































































































import _, { templateSettings } from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";

const globals = namespace("globals");

@Component({
    components: {}
})
export default class CompImage extends Vue {
  // @Prop() value!: string;
  @Prop() src!: string;
  @Prop() width!: string;
  @Prop() height!: string;
  @Prop() compSettings!: string;
  @Prop() fillContainer?: boolean;
  @Prop() imagePosition!: string; // neu: z.B. "left top", "right center", "top", "bottom right"
  @Prop() createdWithAi!: boolean;
  @Prop() altText!: string;

  settings: any = null;
  showDialog = false;
  enableZoom = false;
  showCloseBtn = false;
  zoomerHeight = "500px";
  zoomerWidth = "500px";

  // neue Felder für natürliche Bildgröße
  imgNaturalWidth = 0;
  imgNaturalHeight = 0;
  imgLoaded = false;

  $refs!: {
    zoomer: any;
  };

  mounted() {
    if (this.compSettings) {
      this.settings = JSON.parse(this.compSettings);
      this.enableZoom = this.settings?.enableZoom ?? false;
    }

    this.setZoomerWindowSize();
  }

  async onOpenDlg() {
    if (!this.enableZoom)
      return;

    this.showDialog = true;
    await this.$globalHelper.delay(250);
    this.setZoomerWindowSize();
    this.showCloseBtn = true;
    this.$refs.zoomer.reset();
    // this.$refs.zoomer.zoomOut(0.5)
  }

  onCloseDlg() {
    this.showCloseBtn = false;
    this.$refs.zoomer.reset();
    this.showDialog = false;
  }

  @Watch("compSettings")
  async onCompSettingsChange() {
    if (this.compSettings) {
      this.settings = JSON.parse(this.compSettings);
      this.enableZoom = this.settings?.enableZoom ?? false;
    }
  }

  get isFillContainer() {
    if (this.fillContainer !== undefined && this.fillContainer !== null)
      return this.fillContainer;
    return this.settings?.fillContainer ?? false;
  }

  get imagePos() {
    if (this.imagePosition && this.imagePosition.trim().length > 0) {
      return this.imagePosition.trim();
    }
    if (!this.settings?.imagePosition || this.settings?.imagePosition.trim().length === 0) {
      return "center";
    }
    return this.settings?.imagePosition;
  }

  get alt() {
    if (this.altText && this.altText.trim().length > 0) {
      return this.altText.trim();
    }
    if (!this.settings?.altText || this.settings?.altText.trim().length === 0) {
      return "";
    }
    return this.settings?.altText;
  }

  get aiCreated() {
    if (this.createdWithAi !== undefined && this.createdWithAi !== null)
      return this.createdWithAi;
    return this.settings?.createdWithAi ?? false;
  }

  // Gibt das CSS-Value für object-position zurück (Standard: "center")
  // get objectPositionCss() {
  //   if (this.objectPosition && this.objectPosition.trim().length > 0) {
  //     return this.objectPosition.trim();
  //   }
  //   return "center";
  // }

  // neu: reload wenn src has changed
  // @Watch("src")
  // onSrcChange() {
  //   this.loadNaturalSize();
  // }

  // loadNaturalSize() {
  //   this.imgLoaded = false;
  //   this.imgNaturalWidth = 0;
  //   this.imgNaturalHeight = 0;
  //   if (!this.src) return;
  //   const i = new Image();
  //   // set crossOrigin if needed: i.crossOrigin = "anonymous";
  //   i.onload = () => {
  //     this.imgNaturalWidth = i.naturalWidth || i.width || 0;
  //     this.imgNaturalHeight = i.naturalHeight || i.height || 0;
  //     this.imgLoaded = true;
  //     // force re-evaluation / reflow
  //     this.$nextTick(() => {});
  //   };
  //   i.onerror = () => {
  //     this.imgLoaded = false;
  //   };
  //   i.src = this.src;
  // }

  get widthInPixel() {
    if (!this.width) return null;
    const w = (this.width as any);
    if (typeof w === 'number') return w + 'px';
    const s = String(w);
    if (s.endsWith("px") || s.endsWith("%")) return s;
    return s + "px";
  }

  get heightValue() {
    if (!this.height) return this.isFillContainer ? "100%" : null;
    const h = (this.height as any);
    if (typeof h === 'number') return h;
    const s = String(h);
    if (s.endsWith("px")) return s.substring(0, s.length - 2);
    return s;
  }

  setZoomerWindowSize() {
    this.zoomerHeight = window.innerHeight + "px";
    this.zoomerWidth = window.innerWidth + "px";
  }
}
